import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import {
  BrandEmailIntegration,
  BrandEmailIntegrationImap,
  BrandInvitePartnerEmail,
} from "../../../../shared/models/brandEmailIntegration";
import { BrandService } from "../../../../shared/services/api/brand.service";
import { HttpClient } from "../../../../shared/services/http-client";

@Injectable()
export class BrandEmailIntegrationService {
  constructor(
    private readonly http: HttpClient,
    private readonly brandService: BrandService,
  ) {}

  getGmailConnectionUrl(): Observable<string> {
    const brandId = this.brandService.currentBrandId;
    return this.http
      .get(`brand/${brandId}/gmail_connection_url`)
      .pipe(map(({ body }) => body.url));
  }

  getOutlookConnectionUrl(): Observable<string> {
    const brandId = this.brandService.currentBrandId;
    return this.http
      .get(`brand/${brandId}/outlook_connection_url`)
      .pipe(map(({ body }) => body.url));
  }

  createOrUpdateImapConnection(
    createOrUpdateImapConnectionParameters: BrandEmailIntegrationImap,
  ): Observable<void> {
    const brandId = this.brandService.currentBrandId;
    return this.http
      .put(
        `brand/${brandId}/imap_connection`,
        createOrUpdateImapConnectionParameters,
      )
      .pipe(map(() => {}));
  }

  getCurrentEmailIntegration(
    locale: string,
    campaignId: number,
  ): Observable<BrandEmailIntegration> {
    const brandId = this.brandService.currentBrandId;
    return this.http
      .get(
        `brand/${brandId}/campaign/${campaignId}/email_integration_connection?locale=${locale}`,
      )
      .pipe(map(({ body }) => new BrandEmailIntegration(body)));
  }

  disconnectCurrentEmailIntegration(): Observable<void> {
    const brandId = this.brandService.currentBrandId;
    return this.http
      .del(`brand/${brandId}/email_integration_connection`)
      .pipe(map(() => {}));
  }

  sendBrandPartnerInviteEmail(
    campaignId: number,
    brandEmail: BrandInvitePartnerEmail,
  ): Observable<void> {
    const brandId = this.brandService.currentBrandId;
    return this.http
      .post(
        `brand/${brandId}/campaign/${campaignId}/partner_invite_email`,
        brandEmail,
      )
      .pipe(map(() => {}));
  }
}
